<template>
    <div class="blog-footer">
        <div class="blog-footer__tag-list">
            <template v-for="tag in tagList">
                <blogpost-tag :key="tag.id" :id="tag.id">{{tag.description}}</blogpost-tag>
            </template>
        </div>
    </div>
</template>

<script>

    import BlogpostTag from '@components/BlogpostTag'

    export default {
        name: "BlogFooter",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            tagList() {
                const {data} = this
                return data.tags || []
            }
        },
        components: {
            BlogpostTag
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .blog-footer {
        margin-top: $paddingLG*2;
        margin-bottom: $paddingLG*2;
        border-top: 1px solid $borderColor;
        border-color: $borderColor;
        border-color: var(--borderColor);

        &__tag-list {
            margin-top: $paddingLG*2;
            margin-bottom: $paddingLG*2;
        }
    }
</style>